export class CompanyInfo {
    event: string;
    companyId: number;
    countryId:string;
    createdBy: number = 1;
    createdDate: Date;
    status: boolean;
    organizationId: number = 0;
    organization?: string = '';
    licenseDetails?: string = '';
    fiscalYear: string='0';
    licId: string = '';
    productCode: string = '1';
    databaseName: string
    companyName: string;
    start_Date: Date;
    end_Date: Date;
    accountingSys: string;

    country: string;
    //countryId:string;
    address: string;
    contactPerson: string;
    mobileNo: string;
    phoneNo: string="";
    emailId: string;
    wardNo?: number;
    provinceId?: number;
    districtId?: number;
    cityRuralMunicipalityId?: number;
    pan?: string;
    cuid?: string = '123';
    userId?: string = '0'
    selected?: boolean
    isAssign: boolean = true;
    isPastDateAllow: boolean = false;
    noOfPastDay?: number = 0;
    countryCode?: string = "";

    branchName?: string = "";
    branchAddress?: string = "";
    branchPhone?: string = "";
    branchMobileNo?: string = "";

    ird: boolean = false
    version: string;



}